export default {
  UPDATE_TEMP_FILE: 'UPDATE_TEMP_FILE',
  REMOVE_TEMP_FILE: 'REMOVE_TEMP_FILE',
  CLEAR_ALL_TEMP_FILES: 'CLEAR_ALL_TEMP_FILES',
  UPDATE_MUL_TEMP_FILE: 'UPDATE_MUL_TEMP_FILE',
  REMOVE_MUL_TEMP_FILE: 'REMOVE_MUL_TEMP_FILE',
  REMOVE_MUL_TEMP_FILES: 'REMOVE_MUL_TEMP_FILES',
  UPDATE_MUL_FILES: 'UPDATE_MUL_FILES',
  UPDATE_MUL_TEMP_FILE_BY_ID: 'UPDATE_MUL_TEMP_FILE_BY_ID',
};



// WEBPACK FOOTER //
// ./src/reducers/upload/types.js